import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import ScreeningTrombolisisSvc from "@/services/ScreeningTrombolisis";

@Module({ store, dynamic: true, namespaced: true, name: "screening-trombolisis" })
class ScreeningTrombolisisModule extends VuexModule {
  data: any = null;
  loading = false;

  @Mutation SET_DATA(val: any) {
    this.data = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await ScreeningTrombolisisSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_DATA(data || null);
    } catch {
      this.SET_DATA(null);
    }

    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);

    try {
      const dt = await ScreeningTrombolisisSvc.find(id);
      const { data } = dt.data;
      this.SET_DATA(data || null);
    } catch {
      // ignore
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_DATA(null);
  }
}

export const storeScreeningTrombolisis = getModule(ScreeningTrombolisisModule);
